import useLenis from "@/hooks/useLenis";
import { Disclaimer } from "@/components/site/Disclaimer";
import { Navbar } from "@/components/site/Navbar";
import { Hero } from "@/components/site/Hero";
import { MarqueeStrip } from "@/components/site/MarqueeStrip";
import { About } from "@/components/site/About";
import { PracticeAreas } from "@/components/site/PracticeAreas";
import { Services } from "@/components/site/Services";
import { Booking } from "@/components/site/Booking";
import { Footer } from "@/components/site/Footer";
import { WhatsAppButton } from "@/components/site/WhatsAppButton";

export default function Home() {
  useLenis();
  return (
    <div className="bg-white" data-testid="home-page">
      <Disclaimer />
      <Navbar />
      <Hero />
      <MarqueeStrip />
      <About />
      <PracticeAreas />
      <Services />
      <Booking />
      <Footer />
      <WhatsAppButton />
    </div>
  );
}
